<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="12">
          <h1>Акции</h1>
        </v-col>
      </v-row>
      <v-tabs v-model="tab">
        <v-tab>Список</v-tab>
        <v-tab>Кешбек</v-tab>
        <v-tab>Подарки</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col class="text-right">
              <v-btn @click="$router.push({ name: 'sale-create'})">Создать</v-btn>
            </v-col>
          </v-row>
          <v-data-table
                  no-data-text="Нет акций"
                  no-results-text="По заданному запросу ничего не найдено"
                  :headers="headers"
                  :items="sales"
                  :options.sync="options"
                  :fixed-header="true"
                  height="70vh"
                  :footer-props="footerProps"
                  :header-props="{sortIcon: 'icon-custom-arrow'}"
                  :loading="loading"
                  :items-per-page="-1"
                  loading-text="Загрузка акций... Подождите пожалуйста"
          >
            <template v-slot:item.is_cashback="{item, index}">
              <v-simple-checkbox v-model="item.is_cashback" disabled></v-simple-checkbox>
            </template>
            <template v-slot:item.actions="{item, index}">
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                          small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item @click="$router.push({ name: 'sale-edit', params: { id: item.id } })">
                    <v-list-item-title>Редактировать</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="submitDialog = true; submitItem = item">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <cashback></cashback>
        </v-tab-item>
        <v-tab-item>
          <gift></gift>
        </v-tab-item>
      </v-tabs-items>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import ProductService from './../../api/ProductService'
  import SaleService from "../../api/SaleService";
  import Cashback from "./Cashback";
  import Gift from "./Gift";

  export default {
    name: 'SalesIndex',
    components: {Cashback, Gift},
    data: () => ({
      dialog: false,
      tab: 0,
      overlay: false,
      loading: true,
      tags: [],
      submitDialog: false,
      submitItem: null,
      options: {},
      footerProps: {
        itemsPerPageText: 'Акций на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },
      headers: [
        {
          text: 'Акция',
          value: 'name',
        },
        {
          text: 'Дата начала',
          value: 'date_from'
        },
        {
          text: 'Дата окончания',
          value: 'date_to'
        },
        {
          text: 'Время от',
          value: 'time_from',
        },
        {
          text: 'Время до',
          value: 'time_to',
        },
        {
          text: 'Кешбек',
          value: 'is_cashback'
        },
        {
          value: 'actions',
          sortable: false,
          width: "5%"},
      ],
      sales: []
    }),
    mounted() {
      this.getDataFromApi()

    },
    watch: {

    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeSale(item)
        } else {
          // this.massDelete()
        }
      },
      removeSale(item){
        this.loading = true
        SaleService.remove(item.id).then(response => {
            this.getDataFromApi()
        })
      },
      getDataFromApi() {
        this.loading = true

        SaleService.list()
          .then(response => {
            this.sales = response.data
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss">


</style>


<style lang="scss" scoped>

</style>
